function setTestData(el, binding) {
  const enabled =
    window?.aira_test_data?.enabled === true
  if (!enabled) return
  
  const value = binding.value

  if (typeof value === 'string') {
    // Caso simple: v-test="'boton-login'"
    el.setAttribute('data-test', value)
  } else if (typeof value === 'object' && value !== null) {
    // Caso múltiple: v-test="{ id: 'login', role: 'button' }"
    Object.entries(value).forEach(([key, val]) => {
      el.setAttribute(`data-test-${key}`, val)
    })
  }
}

export default {
  bind: setTestData,
  // Vuelve a escribir los atributos cuando cambian los datos (p. ej. una fecha
  // actualizada al guardar o un elemento reutilizado en un v-for)
  componentUpdated: setTestData
}
